import history from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { addSubCategoryMutation as mutation } from '../../../lib/graphql';

export const addSubCategory = (
  id,
  name,
  description,
  image,
  categoryId,
  status,
  inclusions,
  typicalArrival
) => {

  return async (dispatch, getState, { client }) => {
    try {

      dispatch(setLoaderStart('AddSubCategory'));

      const { data } = await client.mutate({
        mutation,
        variables: {
          id,
          name,
          description,
          image,
          categoryId,
          status,
          inclusions,
          typicalArrival
        }
      });

      if (data?.addSubCategory?.status === 200) {
        showToaster({ messageId: 'addSubCatSuccess', requestContent: { id }, toasterType: 'success' });
        history.push('/siteadmin/sub-category');
      } else {
        showToaster({ messageId: 'errorMessage', requestContent: { content: data?.addSubCategory?.errorMessage }, toasterType: 'error' });
      }
      dispatch(setLoaderComplete('AddSubCategory'));
    } catch (err) {
      showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
      dispatch(setLoaderComplete('AddSubCategory'));
    }
  }
}